import React, { useState } from "react";
import { requestPasswordReset } from "../services/authService";
import { useNavigate } from "react-router-dom";


const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState('');
    const [msg, setMsg] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate=useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setMsg('');
        try {
            await requestPasswordReset({ email });
            setMsg('Check your email for the reset link.');
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }

    const handleClose=()=>{
        navigate('/smartcity/login')
    }

    return (
        <div className="max-w-md mx-auto p-6 bg-white shadow-md rounded-lg border mt-10">
            <div className="flex items-center justify-center">
            <h2 className="text-2xl font-semibold text-center mb-4 mx-auto">Forgot Password</h2>
            <span className="mb-4 text-xl cursor-pointer text-gray-500 pr-1" onClick={handleClose}>x</span>
            </div>
            {msg && <div className="text-green-500">{msg}</div>}
            {error && <div className="text-red-500">{error}</div>}
            <form onSubmit={handleSubmit}>
                <input
                    id="email"
                    type="email"
                    className="border p-2 w-full mb-4 outline-blue-400"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled={loading}
                />
                <button type="submit" className={`bg-blue-500 text-white p-2 rounded w-full ${loading? 'opacity-50':''}`}>
                   {loading ? 'Sending...':'Send Reset Link'}
                </button>
            </form>
        </div>
    )
}

export default ForgotPassword;